module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page wallet"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('mu-appbar', {
    staticClass: "center"
  }, [_c('router-link', {
    attrs: {
      "slot": "left",
      "to": "/wallet/unionPayValid"
    },
    slot: "left"
  }, [_c('mu-icon', {
    attrs: {
      "value": "keyboard_arrow_left",
      "color": "white"
    }
  })], 1), _vm._v(" "), _c('span', {
    staticClass: "topT left"
  }, [_vm._v("提示")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "main"
  }, [_c('mu-icon', {
    attrs: {
      "value": "check_outline",
      "color": "#27ba69",
      "size": "50"
    }
  }), _c('br'), _vm._v(" "), _c('p', [_vm._v("支付成功!")]), _vm._v(" "), _c('mu-raised-button', {
    style: ({
      width: '60%',
      height: '50px',
      margin: '20%'
    }),
    attrs: {
      "href": "#/wallet/valueCardDetail",
      "label": "查看储值卡明细",
      "primary": ""
    },
    on: {
      "click": _vm.post
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e20ae3a0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/wallet/recharge/paySuccess.vue
// module id = 1604
// module chunks = 18